module.exports = __webpack_public_path__ + "static/media/Twynsta.6cddbc3d.jpg";